
const AboutHero = () => {
  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/1d04d6c9e50ba0a97f0e199bc5aad0cc.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About Landmark Cooperative
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Empowering immigrants and residents in Calgary through accessible financial services and community support
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#mission" 
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Our Mission
            </a>
            <a 
              href="#team" 
              className="bg-white/20 hover:bg-white/30 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Meet Our Team
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
